import {
    SET_VEHICLE_CAPACITY,
} from "./VehicleCapacityType";

const initialState = {
    vehicleCapacityDropDown: []
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_VEHICLE_CAPACITY:
            return {
                ...state,
                vehicleCapacityDropDown: action.vehicleCapacityDropDown,
            };
        default:
            return state;
    }
};

export default reducer;
